<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre9" id="pgepubid00001">
      Contents
    </h2>
<table class="calibre11" summary="">
<tbody class="calibre12"><tr class="calibre13">
<td class="calibre14">
<a href="#/Text/Section0003"> CHAPTER I. </a>
</td>
<td class="calibre14">
          A DOUBLE ENIGMA
        </td>
</tr>
<tr class="calibre13">
<td class="calibre14">
<a href="#/Text/Section0004"> CHAPTER II. </a>
</td>
<td class="calibre14">
          THE TENANT OF THE NEW HALL
        </td>
</tr>
<tr class="calibre13">
<td class="calibre14">
<span href="#/Text/Section0005" title="Link target outside of Sample"> CHAPTER III. </span>
</td>
<td class="calibre14">
          A HOUSE OF WONDERS
        </td>
</tr>
<tr class="calibre13">
<td class="calibre14">
<span href="#/Text/Section0006" title="Link target outside of Sample"> CHAPTER IV. </span>
</td>
<td class="calibre14">
          FROM CLIME TO CLIME
        </td>
</tr>
<tr class="calibre13">
<td class="calibre14">
<span href="#/Text/Section0007" title="Link target outside of Sample"> CHAPTER V. </span>
</td>
<td class="calibre14">
          LAURA'S REQUEST
        </td>
</tr>
<tr class="calibre13">
<td class="calibre14">
<span href="#/Text/Section0008" title="Link target outside of Sample"> CHAPTER VI. </span>
</td>
<td class="calibre14">
          A STRANGE VISITOR
        </td>
</tr>
<tr class="calibre13">
<td class="calibre14">
<span href="#/Text/Section0009" title="Link target outside of Sample"> CHAPTER VII. </span>
</td>
<td class="calibre14">
          THE WORKINGS OF WEALTH
        </td>
</tr>
<tr class="calibre13">
<td class="calibre14">
<span href="#/Text/Section0010" title="Link target outside of Sample"> CHAPTER VIII. </span>
</td>
<td class="calibre14">
          A BILLIONAIRE'S PLANS
        </td>
</tr>
<tr class="calibre13">
<td class="calibre14">
<span href="#/Text/Section0011" title="Link target outside of Sample"> CHAPTER IX. </span>
</td>
<td class="calibre14">
          A NEW DEPARTURE
        </td>
</tr>
<tr class="calibre13">
<td class="calibre14">
<span href="#/Text/Section0012" title="Link target outside of Sample"> CHAPTER X. </span>
</td>
<td class="calibre14">
          THE GREAT SECRET
        </td>
</tr>
<tr class="calibre13">
<td class="calibre14">
<span href="#/Text/Section0013" title="Link target outside of Sample"> CHAPTER XI. </span>
</td>
<td class="calibre14">
          A CHEMICAL DEMONSTRATION
        </td>
</tr>
<tr class="calibre13">
<td class="calibre14">
<span href="#/Text/Section0014" title="Link target outside of Sample"> CHAPTER XII. </span>
</td>
<td class="calibre14">
          A FAMILY JAR
        </td>
</tr>
<tr class="calibre13">
<td class="calibre14">
<span href="#/Text/Section0015" title="Link target outside of Sample"> CHAPTER XIII.    </span>
</td>
<td class="calibre14">
          A MIDNIGHT VENTURE
        </td>
</tr>
<tr class="calibre13">
<td class="calibre14">
<span href="#/Text/Section0016" title="Link target outside of Sample"> CHAPTER XIV. </span>
</td>
<td class="calibre14">
          THE SPREAD OF THE BLIGHT
        </td>
</tr>
<tr class="calibre13">
<td class="calibre14">
<span href="#/Text/Section0017" title="Link target outside of Sample"> CHAPTER XV. </span>
</td>
<td class="calibre14">
          THE GREATER SECRET</td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?766083ed